/* eslint-disable eqeqeq */
import axios from 'axios';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Box, Button, Checkbox, FormControlLabel, Modal, Paper, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';

import PaymentModals from '../../modals/views/PaymentModals';
import ChargesViewTable from '../../tables/views/paymentsTab/ChargesTable';

import { apiRoute } from '../../../App';
import { BatchContext } from '../../../context/BatchMgmtContext';
import { CaseContext } from '../../../context/CaseContext';
import { SystemContext } from '../../../context/SystemContext';

const ChargesBox = (props) => {
    const {
        modal,
        handleClose,
        handleOpen,
        violationBalance,
        setViolationBalance,
        openBatches,
        updateCaseBalance,
        violation,
        setViolation,
        modalType,
        modalWidth,
        ts,
        loading,
        setLoading,
        selectedPayment,
        receiptNumber,
        setReceiptNumber,
        state,
        retrieveReceiptPayment,
        setRetrieveReceiptPayment,
        userName,
        violationRows,
        setViolationRows,
        checked,
        setChecked,
        left,
        setLeft,
        right,
        setRight,
        creditCardViolationCheckedItems,
        setCreditCardViolationCheckedItems,
        chargeBack,
        setChargeBack,
        chargeBackSettleDate,
        setChargeBackSettleDate,
        chargeBackSettlement,
        setChargeBackSettlement,
    } = props;

    const { setPaymentBatchNumber } = useContext(BatchContext);

    const { caseView, setCaseView, chargesRows, setChargesRows, violationId, balance } = useContext(CaseContext);

    const { partialPaymentChecks } = useContext(SystemContext);

    const { caseNumber } = useParams();

    const [violationView, setViolationView] = useState({});

    // Check if Sys Codes have ALLOW_PARTIAL entry and its defaultValue is true
    const isPartialPaymentAllowedInSysCodes = partialPaymentChecks.some((item) => {
        return item.description === 'ALLOW_PARTIAL' && item.defaultValue === 'Y';
    });

    const overridePartialPaymentHandler = (e) => {
        const payload = {
            ...caseView,
            overridedPartialPayment: e.target.checked ? 'Y' : 'N',
        };
        axios.put(`${apiRoute}/api/CaseTbls/${caseNumber}`, payload)
            .then(() => {
                setCaseView(payload);
            })
            .catch((err) => {
                toast.error(`Error ${err.response.status} while disabling partial payments on this case.`, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'colored',
                });
            });
    };

    return (
        <Paper sx={{ m: '1vh 0' }} elevation={10}>
            <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', height: 'auto', m: 'auto', p: '.5vh', display: "flex" }}>
                <h6 style={{ fontWeight: 'bold', fontSize: 'inherit', marginBottom: '0px' }}>Violations With Outstanding Balances</h6>
            </Paper>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0.5rem', width: '99%', m: '0 auto', gap: '1rem' }}>
                <Paper sx={{ width: '84.5%', height: '21.5vh' }} elevation={10}>
                    <ChargesViewTable
                        setViolationBalance={setViolationBalance}
                        setViolationView={setViolationView}
                        setViolation={setViolation}
                        chargesRows={chargesRows}
                        setChargesRows={setChargesRows}
                    />
                </Paper>

                <Paper sx={{ width: '16%', textAlign: 'center' }} elevation={10}>

                    <Paper className="border-radius-bottom" sx={{ backgroundColor: 'steelblue', color: 'white', p: '.5vh', marginRight: '0vw', display: 'flex' }}>
                        <h6 style={{ marginTop: '.2vh', mb: '0vh' }}><strong>Payment Options</strong></h6>
                    </Paper>

                    <Box sx={{ width: '99%', m: '.35vh auto 0 auto', p: '.5rem' }}>
                        <Tooltip
                            title={
                                chargesRows.length < 1 && balance === 0.00
                                    ? 'No outstanding balances to make a payment on'
                                    : ''
                            }
                            placement="left"
                        >
                            <span>
                                <Button
                                    disabled={chargesRows.length < 1 || caseView.isCasePaymentLocked == true || !state.isActive || state.isDeleted || state.caseStatus === 'DISMISSED'}
                                    onClick={() => {
                                        if (!violationId) {
                                            toast.error(`Select an unpaid violation to accept a payment`, {
                                                position: 'top-right',
                                                autoClose: 2000,
                                                hideProgressBar: true,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: 'colored',
                                            });
                                        } else {
                                            setReceiptNumber('');
                                            handleOpen('newPayment', '75%');
                                        }
                                    }}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: 'steelblue',
                                        color: 'white',
                                        width: '100%',
                                        height: '3rem',
                                        mb: '1vh',
                                        fontSize: '1rem',
                                        fontWeight: '500'
                                    }}
                                >
                                    Time Served
                                </Button>
                            </span>
                        </Tooltip>
                        <Tooltip
                            title={
                                chargesRows.length < 1 && balance === 0.00
                                    ? 'No outstanding balances to make a payment on'
                                    : ''
                            }
                            placement="left"
                        >
                            <span>
                                <Button
                                    disabled={chargesRows.length < 1 || caseView.isCasePaymentLocked == true || !state.isActive || state.isDeleted || state.caseStatus === 'DISMISSED'}
                                    onClick={() => {
                                        handleOpen('quickPayment', '75%');
                                        setReceiptNumber('');
                                    }}
                                    variant="contained"
                                    sx={{ backgroundColor: 'steelblue', color: 'white', width: '100%', mb: '1vh', height: '3rem', fontSize: '1rem', fontWeight: '500' }}
                                >
                                    Cash & Checks
                                </Button>
                            </span>
                        </Tooltip>
                        <Tooltip
                            title={
                                chargesRows.length < 1 && balance === 0.00
                                    ? 'No outstanding balances to make a payment on'
                                    : state.issuedChargeBack ? 'Credit Card Payments Locked Due To Charge Back Dispute On Case'
                                        : state.isCreditCardPaymentsLocked ? 'Credit Card Payments Locked On This Case'
                                            : null
                            }
                            placement="left"
                        >
                            <span>
                                <Button
                                    disabled={state.issuedChargeBack | state.isCreditCardPaymentsLocked | chargesRows.length < 1 || caseView.isCasePaymentLocked == true || !state.isActive || state.isDeleted || state.caseStatus === 'DISMISSED'}
                                    onClick={() => {
                                        setViolation('none');
                                        setPaymentBatchNumber('');
                                        setReceiptNumber('');
                                        handleOpen('creditCard', '60%')
                                    }}
                                    variant="contained"
                                    sx={{ backgroundColor: 'steelblue', color: 'white', width: '100%', height: '3rem', fontSize: '1rem', fontWeight: '500' }}
                                >
                                    Credit Card
                                </Button>
                            </span>
                        </Tooltip>
                        <Modal
                            open={modal}
                            sx={
                                {
                                    width: modalWidth,
                                    margin: '2vh auto'
                                }
                            }
                        >
                            <PaymentModals
                                handleClose={handleClose}
                                violationBalance={violationBalance}
                                openBatches={openBatches}
                                violationView={violationView}
                                updateCaseBalance={updateCaseBalance}
                                violation={violation}
                                setViolation={setViolation}
                                modalType={modalType}
                                ts={ts}
                                loading={loading}
                                setLoading={setLoading}
                                selectedPayment={selectedPayment}
                                handleOpen={handleOpen}
                                receiptNumber={receiptNumber}
                                setReceiptNumber={setReceiptNumber}
                                citationState={state}
                                setRetrieveReceiptPayment={setRetrieveReceiptPayment}
                                retrieveReceiptPayment={retrieveReceiptPayment}
                                overridedPartialPayment={caseView?.overridedPartialPayment}
                                userName={userName}
                                violationRows={violationRows}
                                setViolationRows={setViolationRows}
                                checked={checked}
                                setChecked={setChecked}
                                left={left}
                                setLeft={setLeft}
                                right={right}
                                setRight={setRight}
                                checkedItems={creditCardViolationCheckedItems}
                                setCheckedItems={setCreditCardViolationCheckedItems}
                                chargeBack={chargeBack}
                                setChargeBack={setChargeBack}
                                chargeBackSettleDate={chargeBackSettleDate}
                                setChargeBackSettleDate={setChargeBackSettleDate}
                                chargeBackSettlement={chargeBackSettlement}
                                setChargeBackSettlement={setChargeBackSettlement}
                            />
                        </Modal>
                    </Box>
                </Paper>

            </Box>
            <Box ml={3}>
                {isPartialPaymentAllowedInSysCodes && (
                    <FormControlLabel
                        label="Disallow Partial Payments"
                        control={
                            <Checkbox
                                checked={caseView?.overridedPartialPayment && caseView?.overridedPartialPayment === 'Y'}
                                onChange={overridePartialPaymentHandler}
                            />
                        }
                    />
                )}
            </Box>
        </Paper>
    );
}

export default ChargesBox;